module.exports = __webpack_public_path__ + "b9afd72f05a86fa38b4563a7b5a2feca.svg";